import { useMemo } from 'react';
import { useGetStatsQuery } from '@platform/state/api';
import type { IRecordTypeDefinition } from '@platform/core/types';
import type { IRiskCounts } from './IRiskCounts';
import { acceptedFilter, acceptedHighOf, criticalFilter, isRiskRegister, levelField, openCriticalOf } from './riskAdvice';

/**
 * Лічильники порад реєстру ризиків (прототип v4, модуль Ризики): відкриті критичні ризики (статистика `by=status` з фільтром рівня) і
 * критичні або високі ризики зі стратегією «Прийняття» (статистика `by=level` з фільтром стратегії). Тип без полів рівня й стратегії — без
 * запитів, готовий одразу.
 */
export function useRiskCounts(ws: string, rt: IRecordTypeDefinition): IRiskCounts {
  const risk = isRiskRegister(rt);
  const critical = useGetStatsQuery({ ws, rt: rt.key, by: 'status', params: { filter: criticalFilter } }, { skip: !risk });
  const accepted = useGetStatsQuery({ ws, rt: rt.key, by: levelField, params: { filter: acceptedFilter } }, { skip: !risk });
  const closed = useMemo(() => new Set(rt.statuses.list.filter((s) => s.closed).map((s) => s.value)), [rt.statuses]);
  if (!risk) return { ready: true };
  const done = (q: { data?: unknown; error?: unknown }) => Boolean(q.data) || Boolean(q.error);
  return { critical: openCriticalOf(critical.data, closed), accepted: acceptedHighOf(accepted.data), ready: done(critical) && done(accepted) };
}
